import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DashboardViewApiService } from './dashboard-view-api.service';
import { DashboardView } from 'ops/common/models/dashboard-view';

@Injectable({ providedIn: 'root' })
export class DashboardViewService {
    constructor(private api: DashboardViewApiService) {}

    public getDashboard(): Observable<DashboardView> {
        return this.api.getDashboard();
    }

    public update(dashboard: DashboardView): Observable<DashboardView> {
        return this.api.update(dashboard);
    }
}
